<template>
    <!-- ///Dialog Tbl Archivos ///////////////////////// -->
    <v-content>
    <v-container grid-list-bg class="pb-0" style="background-color:#FFFFFF">
      <template>
        <v-dialog
          v-model="dialogarchivos"
          max-width="1100"        
          persistent 
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <!-- <v-toolbar-title>{{ oidcUser.Id_Empleado }}</v-toolbar-title> -->
              <v-toolbar-title>{{FraccionNombre}}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-divider></v-divider>

            <!-- <v-flex v-model="tablar"> -->
            <v-card>
              <v-data-table
                :headers="aheaders"
                :items="adesserts"
                sort-by="calories"
                class="elevation-1"
                 ref="myTable"
                 v-model="selected" 
                 item-key="name"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Archivos
                    </v-toolbar-title>
                    <v-divider class="mx-3" inset vertical></v-divider>
                    <v-toolbar-title>
                        <p>&nbsp</p>
                         <v-switch v-model="allowDrag" label="Ordenar Manualmente"></v-switch>
                    </v-toolbar-title>                    
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <!-- <template v-slot:item.fechaCreacion="{ item }">
                 
                  {{GetFormattedDate(item.fechaCreacion)}}
                </template>-->
        <template #body="props">
        <draggable
          :list="props.items"
          tag="tbody"
          :disabled="!allowDrag"
          :move="onMoveCallback"
          :clone="onCloneCallback"
          @end="onDropCallback"
        >
          <data-table-row-handler
            v-for="(item, index) in props.items"
            :key="index"
            :item="item"
            :headers="aheaders"
            :item-class="getClass(item)"
          >

                <template v-slot:item.estatus="{ item }">
                  <v-btn
                    depressed
                    small
                    :color="getColor(item.estatus)"
                    dark
                    @click="modalaplica(item)"
                  >{{gettxt(item.estatus)}}</v-btn>
                </template>
                <template v-slot:item.checkbtn="{ item }">
                  <!-- <v-checkbox :value="items.idArchvio" v-model="selected" >:value="cmostrar(item.idArchvio)"</v-checkbox> -->

                  <v-checkbox
                    :input-value="cmostrar(item.estatus)"
                    id="myCheck"
                    @click="cheked(item)"
                    value
                  ></v-checkbox>
                </template>
                <template  v-slot:item.action="{ item }">                                              
                  <v-icon md color="teal darken-2" @click="desArchivo(item)">save_alt</v-icon>
                  <br/>                
                  <v-icon md color="purple" @click="UpdtArchivo(item)">refresh</v-icon>     
                    <br/>                
                  <v-icon md color="red" @click="PregEliminarArchivo(item)">close</v-icon>            
                </template>

                <template v-slot:item.Comprobante="{ item }">
                  <v-icon md class="mr-2" @click="descomprobante(item)">picture_as_pdf</v-icon>
                  <!-- <v-icon small class="mr-2"  @click="open"> find_in_page</v-icon> -->
                </template>
                <template v-slot:no-data>
                  <!-- <v-btn color="primary" @click="modalitem">Reset</v-btn> -->
                </template>
               
          </data-table-row-handler>
        </draggable>
            </template>
              </v-data-table>
            </v-card>
          
          </v-card>
        </v-dialog>


                <v-dialog v-model="modUpdtArchivo" max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Actualizar Archivo</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
              <!--          <v-flex xs12 sm6 d-flex>
                          <v-select
                            v-model="editedArchivo.anio"
                            :items="ddlanio"
                            label="Año"
                            item-value="anio"
                            outlined
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 d-flex>
                          <v-select
                            v-model="editedArchivo.IdPeriodo"
                            :items="ddlperiodo"
                            item-text="periodo"
                            item-value="idPeriodo"
                            label="periodo"
                            outlined
                          ></v-select>
                        </v-flex>-->
                        <v-flex xs12 sm12 d-flex>
                          <form enctype="multipart/form-data">
                            <input
                              type="file"
                              name="file"
                              ref="files"
                              multiple
                              v-on:change="fileChange($event)"
                            />
                          </form>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="modUpdtArchivo = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="upload">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dlgUpdtArch" max-width="300px" >
                  <v-card>
                  <v-card-title>
                    <span class="headline">Actualizar Archivo</span>
                  </v-card-title>
                  <v-card-text>
                    {{msjDialogUpdt}}
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dlgUpdtArch = false">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>

                <v-dialog v-model="dlgEliminarArchivo" max-width="300px" >
                  <v-card>
                  <v-card-title>
                    <span class="headline">Eliminar Archivo</span>
                  </v-card-title>
                  <v-card-text>
                  Esta acción eliminará el archivo, ¿Desea continuar?
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dlgEliminarArchivo = false">No</v-btn>
                    <v-btn color="blue darken-1" text @click="EliminarArchivo()">Si</v-btn>
                  </v-card-actions>
                </v-card>
                </v-dialog>
        </template>
            </v-container>
  </v-content>
</template>

<script>
import { sortItems } from "vuetify/lib/util/helpers";
import DataTableRowHandler from "../DataTableRowHandler.vue";
import draggable from "vuedraggable";
import axunidad from "axios";
import  fraccionServices  from "../../services/FraccionService";
import { axiosSingleton } from "@/plugins/axios";

//let url_api = 'https://colmenac.ugto.mx/rg/Transparencia/'
//let url_api = 'https://localhost:44340/'
let url_api = 'https://enjambrec.ugto.mx/RG/Transparencia/'

let ban_alta=true;

import jsPDF from "jspdf";
export default {
  components: {
    draggable,
    DataTableRowHandler,
  },
  name: "DialogArchivo",
  props: {
  item: {
      type: Object,
      required: true,
    },
   dialog: {
      type: Boolean,
      required: true,
    },
    usuariot: {
      type: String,
      required: true,
    },
      closeDialog: {
      type: Function,
      required: true,
    },

    modalitemDialog :{
      type: Function,
      required: true,
    },
    vidempleado:{
      type: String,
      required: true,
    },
    aheaders:{  type: Array,
      required: true,}
  },
  data() {
    return {
      allowDrag: true,
      dialogarchivos: false,
      selected: [],
      adesserts: [],
      desserts: [],
      FraccionNombre:"",
      modUpdtArchivo: false,
      msjDialogUpdt: "",
      dlgUpdtArch: false,
      dlgEliminarArchivo: false,
      id_archivo_eliminar: 0
    };
  },
  watch: {
      dialog: {
      handler(newValue, oldValue) {
      this.dialogarchivos = newValue;
      this.getData()
      },
    },
  
    
  },
  mounted() {},
  computed: {
    activeHeaders() {
      return this.headers.filter((h) => {
        if (!this.allowDrag && h.value === "lock") {
          return false;
        }
        return true;
      });
    },
  },
  methods: {
       //carga de archivos//////////////////////////////////////////////////////////////////////////////////////////////
    fileChange(event) {
      console.log(event.target.files[0]);
      this.files = event.target.files[0];
    },
    async UpdtArchivo(item) {
      let self = this;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedArchivo = Object.assign({}, item);
      console.log("modal actualizar archivo", item);
      //self.ddlPeriodo(item);
      this.modUpdtArchivo = true;
    },
    async PregEliminarArchivo(item) {
      let self = this;     
      this.dlgEliminarArchivo = true;
      this.id_archivo_eliminar=item.idArchvio;
    },
    async EliminarArchivo() {
      let self = this;  
      if (self.usuariot == "Administrador") {
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
          fraccionService.EliminarArchivo(this.id_archivo_eliminar)
          .then(r => {
            this.dlgEliminarArchivo = false;
            this.id_archivo_eliminar=0;
            this.getData();
          });
      } 
    },
     async upload() {

      let self = this;
      if (self.usuariot == "Administrador") {      
      this.editedArchivos = {
        idArchvio: this.editedArchivo.idArchvio,
        idFraccion: this.editedArchivo.idFraccion,
        numFraccion: this.editedArchivo.numFraccion,
        tipoFraccion: this.editedArchivo.tipoFraccion,
        aplica: this.editedArchivo.aplica,
        NombreFormulario: this.editedArchivo.NombreFormulario,
        IdUnidad: this.editedArchivo.idUnidad,
        IdPeriodo: this.editedArchivo.IdPeriodo,
        Anio: this.editedArchivo.anio
      };
      // console.log("editedcargar 2", this.editedArchivos);
      let formData = new FormData();

      formData.append("files", this.files);
      formData.append("jsonString", JSON.stringify(this.editedArchivos));
      // console.log(formData);
      this.modUpdtArchivo = false;
      var response = await axunidad
        .post(url_api + "darchivoupdt/",
          formData,
          {
            //  .post(`https://localhost:44340/darchivo/`, formData, {
            headers: { "Content-Type": "multipart/form-data" }
          }
        )
        .then(res => {
          //  alert(res);
          this.msjDialogUpdt = res.data;
          // console.log("guardado" ,llenapdf);

          this.dlgUpdtArch=true;
          // console.log("mandar a pdf",llenapdf);
          //  self.emailcomprobante(llenapdf);
        });
      }
    },
     getClass(item) {
          return item.calories > 500
        ? "cal-high"
        : item.calories > 400
        ? "cal-medium"
        : "cal-low";
    },
    onCloneCallback(item) {
      // Create a fresh copy of item
      const cloneMe = JSON.parse(JSON.stringify(item));

      return cloneMe;
    },
    onMoveCallback(evt, originalEvent) {
      /*const item = evt.draggedContext.element;
      const itemIdx = evt.draggedContext.futureIndex

      //console.log("onMoveCallback",evt.relatedContext);

      if (item.locked) {
        return false;
      }*/

      return true;
    },
    onDropCallback(evt, originalEvent) {
     /* console.log("onDropCallback id_archivo",evt.item._underlying_vm_.idFraccion);
      console.log("onDropCallback id_archivo",evt.item._underlying_vm_.idArchvio);
      console.log("onDropCallback nuevo",evt.newIndex);
      console.log("onDropCallback viejo",evt.oldIndex);*/
      //this.setOrderFiles(evt.item._underlying_vm_.idArchvio,evt.item._underlying_vm_.idFraccion,evt.newIndex,evt.oldIndex);

    let self = this;
    if (self.usuariot == "Administrador") {
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService
          .ordernarArchivos(evt.item._underlying_vm_.idFraccion,evt.item._underlying_vm_.idArchvio,evt.newIndex,evt.oldIndex)
          .then(r => {
              console.log("respuesta: ", r);
          });
      }
    },
    getData(){
      let self = this;
      console.log("desdedialog",self.item)
      this.FraccionNombre = self.item.descripcionCorta;
      // const index = this.desserts.indexOf(self.item);
      console.log("modal", self.usuariot);

      if (self.usuariot == "Administrador") {
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
        fraccionService
          .tblArchivos(self.item.idFraccion)
          .then(r => {
            this.adesserts = r.data.map(e => {
              e.fechaCreacion = e.fechaCreacion
                .substr(0, 10)
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("-");
              //  console.log("pos si", e.fechaCreacion)
              return e;
            });
            console.log("modalitemsadeserts admin", this.adesserts);
          });
      } else {
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
          fraccionService
          .tblArchivosUdependencia(self.item.idFraccion, self.vidempleado)
          .then(r => {
            this.adesserts = r.data.map(e => {
              e.fechaCreacion = e.fechaCreacion
                .substr(0, 10)
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("-");
              //  console.log("pos si", e.fechaCreacion)
              return e;
            });
            console.log("modalitemsadeserts usuario", this.adesserts);
          });
      
        }
    },

       getColor(estatus) {
      //  console.log("color aplica", aplica);
      if (estatus == 1) {
        return "green";
      } else if (estatus == 2) {
        return "red";
      } else if (estatus == 3) {
        return "orange";
      } else if (estatus == 4) {
        return "blue";
      }
    },

    gettxt(estatus) {
      //  console.log("aplica txt", aplica);
      if (estatus == 1) {
        return "Publicado";
      } else if (estatus == 2) {
        return "No activo";
      } else if (estatus == 3) {
        return "revisión";
      } else if (estatus == 4) {
        return "no aprobado";
      }
    },
       cmostrar(estatus) {
      if (estatus == 1) {
        return "true";
      } else {
        return "";
      }
    },
      descomprobante(item) {
      var img = new Image();

      img.addEventListener("load", function() {
        console.log("comprobante", item);
        var movimiento = "";
        if (item.estatus == 1) {
          movimiento = "Alta";
        } else if (item.estatus == 2) {
          movimiento = "Baja";
        } else if (item.estatus == 3) {
          movimiento = "revisión";
        } else if (item.estatus == 4) {
          movimiento = "Reachazado";
        }
        ///revisar fecha modofocacion 
        var moificacionHora= item.fechaModificacion.substr(11, 8);
        // var moificacionFecha= item.fechaModificacion.substr(0, 10);
       var moificacionFecha= item.fechaModificacion
                .substr(0, 10)
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("-");
        var creacion = item.fechaCreacion.substr(0, 19);
        var pr = item.periodo.substr(0, 4);
        var doc = new jsPDF();
        doc.addImage(img, "png", 90, 20, 30, 30);
        doc.setFontSize(16);
        doc.text(35, 65, "PORTAL DE OBLIGACIONES DE TRANSPARENCIA");
        doc.text(50, 75, "COMPROBANTE DE PROCEDIMIENTO");
        doc.line(10, 85, 200, 85);
        doc.setFontSize(14);
        doc.text(70, 95, "UNIVERSIDAD DE GUANAJUATO");
        doc.text(72, 110, "UNIDAD DE TRANSPARENCIA");
        doc.text(20, 125, "Área Universitaria:" + item.nombreUnidad);
        doc.text(20, 140, "Artículo: " + item.descripcionCorta);
        doc.text(
          20,
          155,
          "Nombre del formato: " +
            item.numFraccion +
            "" +
            pr +
            "/" +
            item.anio +
            "/" +
            item.idArchvio
        );
        doc.text(20, 170, "Fecha de registro: " + creacion);
        doc.text(20, 185, "Fecha y hora del movimiento: "+ moificacionFecha+ "  " + moificacionHora );
        doc.text(20, 200, "Tipo de operación: " + movimiento);
        doc.text(
          20,
          215,
          "Periodo de actualización: " + item.periodo + "  " + item.anio
        );
        doc.text(20, 230, "Responsable: " + item.vnombre);
        doc.line(10, 260, 200, 260);
        doc.save(
          item.numFraccion +
            "" +
            pr +
            "/" +
            item.anio +
            "/" +
            item.idArchvio +
            "Comprobante.pdf"
        );
      });
      img.src = require("@/assets/escug.png");
    },
    desArchivo(item) {
      let self = this;
      const index = this.desserts.indexOf(item);
      console.log("Archico", item);
      var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
      fraccionService

        .archivodow(item.idArchvio)
        .then(r => {
          this.adesserts = r.data;
        });
    },
        cheked(item) {
     
      // var checkBox = document.getElementById("myCheck");
      // var text = document.getElementById("text");
      if(ban_alta==true)
      {
        console.log("checkedc !!!!!!");
        ban_alta=false;
      if (item.estatus == 2) {   
        //Guardar check
        var ESTATUS = 1;
        var verdadero = { Id: item.idArchvio, ESTATUS };
        this.editedItem = Object.assign({}, verdadero);
        console.log("chek  guardar ", this.editedItem);
        let self = this;

        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
        fraccionService
          .mostrar(self.editedItem)
          .then(r => {
            ban_alta=true;
            self.modalitem(item);
            this.getData()
          })
          .catch(error => console.error("Error:", error))
          .then(response => console.log("Success:", response));

        console.log("entra a true", item);
      } else {
        console.log("checkedc !!!!!!");
        var ESTATUS = 2;
        var verdadero = { Id: item.idArchvio, ESTATUS };
        this.editedItem = Object.assign({}, verdadero);
        console.log("Chek estatus2", this.editedItem);
        let self = this;
        var fraccionService= new fraccionServices(axiosSingleton.getInstance(), url_api);
        fraccionService
          .mostrar(self.editedItem)
          .then(r => {
            ban_alta=true;
            self.modalitem(item);
            this.getData()
          })
          .catch(error => console.error("Error:", error))
          .then(response => console.log("Success:", response));
        console.log("entra a false", item);
      }
    }
    },
    modalitem(item) {
     
      //this.idemp = this.dts.vidempleado;
      //this.tpUsuario = this.dts.vdescripcion;
      this.dialogarchivos = true;
      this.DgArchivo = item;
      this.arheader = this.aheaders;
    },

  }
};
</script>


<style>
.cal-high {
  background-color: #ffffff;
  text-align: left !important;
}
.cal-medium {
  background-color: #ffffff;
text-align: left !important;
}

.cal-low {
  background-color: #ffffff;
   text-align: left !important;
}
</style>

